export function zurPositionScrollen(element, x) {
    element.scrollTo({
        top: 0,
        left: x,
        behavior: 'smooth'
    });
}

export function zumElementKopfScrollen(element) {
    window.scrollTo({
        top: window.pageYOffset + element.getBoundingClientRect().top - 200,
        behavior: 'smooth'
    });
}
